import { render, staticRenderFns } from "./MiraBarRow.vue?vue&type=template&id=816ec560&scoped=true&"
import script from "./MiraBarRow.vue?vue&type=script&lang=ts&"
export * from "./MiraBarRow.vue?vue&type=script&lang=ts&"
import style0 from "./MiraBarRow.vue?vue&type=style&index=0&id=816ec560&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "816ec560",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
